export const VIDEO_TIMESTAMP_PARAM = 'vts';